const LP_LEADS_REQUEST_TYPE = {
  ACCESS: "ACCESS",
  CREATED: "CREATED",
  SUBMIT_FORM: "SUBMIT_FORM",
  OPPORTUNITY: "OPPORTUNITY",
  SALE: "SALE",
};

export default LP_LEADS_REQUEST_TYPE;
